export default function BellIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="21"
			height="20"
			viewBox="0 0 21 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.60819 12.308C2.43098 13.4697 3.22325 14.276 4.19329 14.6778C7.91226 16.2185 13.0876 16.2185 16.8065 14.6778C17.7766 14.276 18.5688 13.4697 18.3917 12.308C18.2828 11.5941 17.7443 10.9996 17.3453 10.4191C16.8227 9.64941 16.7708 8.80982 16.7707 7.91666C16.7707 4.46487 13.9632 1.66666 10.4999 1.66666C7.03669 1.66666 4.22919 4.46487 4.22919 7.91666C4.22911 8.80982 4.17719 9.64941 3.65459 10.4191C3.25562 10.9996 2.71709 11.5941 2.60819 12.308Z"
				stroke="currentColor"
				stroke-width="1.25"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M7.16675 15.8333C7.54882 17.271 8.89633 18.3333 10.5001 18.3333C12.1038 18.3333 13.4513 17.271 13.8334 15.8333"
				stroke="currentColor"
				stroke-width="1.25"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}
